var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 50 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 18.4641C46.6667 16.9245 46.6667 13.0755 44 11.5359L33.5 5.47372C30.8333 3.93412 27.5 5.85863 27.5 8.93783L27.5 21.0622C27.5 24.1414 30.8333 26.0659 33.5 24.5263L44 18.4641Z",
    fill: "#36ACD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.4641C26.6667 16.9245 26.6667 13.0755 24 11.5359L13.5 5.47372C10.8333 3.93412 7.5 5.85863 7.5 8.93783L7.5 21.0622C7.5 24.1414 10.8333 26.0659 13.5 24.5263L24 18.4641Z",
    fill: "#36ACD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/One.5df41796be726799fa37232d350ae4d0.svg";
export { ForwardRef as ReactComponent };